<template>
  <div>
    <div class="import-strategies-create-entry">
      <div class="import-strategies-create-prop-text">{{name}}</div>
      <div class="import-strategies-create-header">Propertyset Name</div>
      <div class="import-strategies-create-header">Property Name</div>
    </div>
    <div
      class="import-strategies-create-entry"
      v-for="value in $store.state.Ultra.ifc_geometry_values"
      :key="value.prop"
      >
      <div class="import-strategies-create-prop-text">{{value.text}}:</div>
      <input
        class="import-strategies-create-input-field"
        :disabled="disabled"
        :value="strategy[`${prefix ? prefix : ''}${value.prop}_propertyset_name`]"
        @change="$emit('changeValue', {key: `${prefix ? prefix : ''}${value.prop}_propertyset_name`, value: $event.target.value})"
        />
      <input
        class="import-strategies-create-input-field"
        :disabled="disabled"
        :value="strategy[`${prefix ? prefix : ''}${value.prop}_property_name`]"
        @change="$emit('changeValue', {key: `${prefix ? prefix : ''}${value.prop}_property_name`, value: $event.target.value})"
        />
    </div>
  </div>
</template>
<script>
  export default {
    props: ['name', 'strategy', 'prefix', 'disabled'],
    data: () => ({
    }),
  }
</script>
<style>
  .class {

  }
</style>
 